export const AGENT_TRUST_RECEIPT_PANEL_ID = 'agentTrustReceiptPanel';

export type AgentTrustReceiptScenarioId = 'CREATED_BY_AI' | 'EDITED_BY_AI' | 'READ_BY_AI';

export type AgentTrustReceiptActorIconKey =
	| 'rovo-agent'
	| 'space-organizer-agent'
	| 'dev-docs-agent';

export type AgentTrustReceiptAgentType = 'rovo' | 'space-organizer' | 'dev-docs';

export type AgentTrustReceiptActor = {
	id: string;
	name: string;
	type: 'agent' | 'person';
	agentType: AgentTrustReceiptAgentType;
	iconKey: AgentTrustReceiptActorIconKey;
};

export type AgentTrustReceiptScenario = {
	id: AgentTrustReceiptScenarioId;
	label: string;
	description: string;
};

export type AgentTrustReceiptSignal = {
	id: string;
	label: string;
	value: string;
};

export type AgentTrustReceiptEvent = {
	id: string;
	occurredAt: string;
	title: string;
	description: string;
};

export type AgentTrustReceipt = {
	contentId: string;
	actor: AgentTrustReceiptActor;
	scenario: AgentTrustReceiptScenario;
	summary: string;
	events: AgentTrustReceiptEvent[];
	signals: AgentTrustReceiptSignal[];
};
